import React from "react"

interface TurboLogoIconProps {
    className?: string
    size?: number
}

const TurboLogoIcon: React.FC<TurboLogoIconProps> = ({
    className = "",
    size = 16
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 620.28 527.4"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill="currentColor"
        >
            <g>
                <path
                    d="M450.04,149.11l-16.3,37.56-147.86,340.73h-80.2L344.56,207.43c4.26-9.8-2.94-20.76-13.63-20.76H0L31.91,113.17H426.47c18.52,0,30.96,18.98,23.56,35.94Z"
                />
                <g>
                    <path
                        d="M543.06,113.17h41.5l-31.95,73.5-148.58,340.73h-77.43L475.22,186.67l17.64-40.58c8.69-19.99,28.4-32.92,50.2-32.92Z"
                    />
                    <path
                        d="M618.13,35.94l-16.34,37.59H50.13L82.05,0H594.56c18.48,0,30.92,18.98,23.57,35.94Z"
                    />
                </g>
            </g>
        </svg>
    )
}

export default TurboLogoIcon
